import { render } from "./TitleTabletFormComponentDetails.vue?vue&type=template&id=d6493cfa"
import script from "./TitleTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./TitleTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__